<template>
  <div class="vx-col mt-12">
    <div class="vx-col w-full">
      <div class="flex items-end px-3">
        <span class="font-medium text-lg leading-none">Estudiantes relacionados</span>
      </div>
      <vs-divider />
    </div>

    <div class="vx-col md:w-1/2 w-full">
      <div class="flex flex-col">
        <label class="vs-input--label w-full">Documento de identidad</label>
        <div class="flex">
          <div class="w-1/2">
            <v-select
              v-model="student_data.id_document_type"
              :reduce="id_document_type => id_document_type.card_type_id"
              :options="cardTypeOptions"
              :clearable="false"
              name="id_document_type"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              :searchable="false"
            />
          </div>
          <div class="w-1/2 pl-4">
            <vs-input
              class="w-full"
              v-model="student_data.document"
              autocomplete="off"
              v-validate="'max:15'"
              name="document"
              placeholder="Número"
              data-vv-as="Número de Documento"
              :disabled="!student_data.id_document_type"
            />
          </div>
          <div class="flex pl-4">
            <vs-button color="primary" @click="addStudent">Agregar</vs-button>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-2/3 w-full">
        <ag-grid-vue
          class="ag-theme-material w-100 my-4 ag-grid-table"
          ref="agGridTable"
          :columnDefs="columnDefs"
          :rowData="studentsDataLocal"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :enableRtl="$vs.rtl"
          :modules="modules"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "@ag-grid-community/vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { AllCommunityModules } from '@ag-grid-community/all-modules';
import CellRendererActions from '../cell-renderer/CellRendererActions.vue';
import UserFunctions from '../UserFunctions';
import vSelect from 'vue-select';

export default {
  mixins: [UserFunctions],
  components: {
      AgGridVue,
      CellRendererActions,
      vSelect
    },
  props: {
    data: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      modules: AllCommunityModules,
      cardTypeOptions: [],
      student_data: {
        id_document_type: '',
        document: '',
      },
      studentsData: [],
      columnDefs: [
          {
            headerName: 'Documento',
            field: 'document',
            width: 150,
            filter: false,
          },
          {
            headerName: 'Nombre',
            field: 'full_name',
            filter: false,
            width: 300,
          },
          {
            headerName: 'Escuela',
            field: 'school_name',
            filter: false,
            width: 200,
          },
          {
            headerName: 'Acciones',
            cellRendererFramework: 'CellRendererActions',
            cellRendererParams: {
              onDelete: this.removeStudent,
            },
          },
        ],
    }
  },
  computed: {
    studentsDataLocal: {
      get() {
        return this.data
      },
      set(students) {
        console.log('llega')
        if(!students) {
          this.$emit('updateStudensData', students)
        }
      }
    },
  },
  methods: {
    showNotify(type,title,text) {
        this.$vs.notify({
          color: type || 'success',
          title: title || 'Correcto!',
          text: text || '',
          time: 8000,
          position: 'top-center',
          iconPack: 'feather',
          icon:'icon-check',
        })
      },
  },
  created() {
    // this.studentsDataLocal = this.data
    this.cardTypeOptions = this.$store.state.AppData.cardTypes
  }
}
</script>

